import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { Accordion } from '../components/Accordion';
import { testimonials } from '../components/testimonials';
export function TeamTraining() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-1056">
      {/* SECTION 1 — HERO OFERTĂ */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32 text-center" data-id="element-1057">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-1058"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-1059"></div>
        <div className="max-w-[900px] mx-auto px-5 md:px-12 relative z-10" data-id="element-1060">
          <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-1061">
            Echipa Care Duce Afacerea Înainte
          </h1>
          <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10" data-id="element-1062">
            Training personalizat de leadership pentru echipa ta:
            responsabilitate, comunicare, roluri clare și aliniere la viziune.
          </p>
          <BookingButton text="Solicită o Ofertă Personalizată" href="/contact" className="px-10 py-5 text-[16px]" data-id="element-1063" />
        </div>
      </section>

      {/* SECTION 2 — DESCRIERE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1064">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-1065">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8 text-center" data-id="element-1066">
            Ai oameni buni. Dar nu ai echipă.
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-1067">
            <p data-id="element-1068">
              Ai investit timp și bani ca să îi aduci. Sunt competenți. Au
              experiență. Dar nu funcționează ca o echipă. Fiecare trage în
              direcția lui. Comunicarea este reactivă, nu proactivă. Rolurile se
              suprapun sau rămân în aer. Conflictele se evită în loc să se
              rezolve. Și tu stai la mijloc, traduci între departamente și
              rezolvi ceea ce ei ar trebui să rezolve între ei.
            </p>
            <p data-id="element-1069">
              Un om bun într-o echipă disfuncțională produce jumătate din cât ar
              putea. O echipă de oameni buni fără aliniere la aceeași viziune
              pierde luni întregi lucrând pe lucruri care nu contează cu
              adevărat. Cu fiecare trimestru în care nu investești în echipă,
              pierzi bani prin decizii amânate, prin conflicte neadresate și
              prin oameni buni care pleacă.
            </p>
            <p className="font-medium text-[#09111F] p-6 bg-[#F1F5F9] rounded-2xl border-l-4 border-[#1D4ED8]" data-id="element-1070">
              Acest training este construit pentru echipe de leadership și
              angajați cheie care au nevoie să treacă de la un grup de indivizi
              la o echipă care funcționează cu responsabilitate, comunicare
              clară și aliniere reală la direcția companiei. Nu primesc
              motivație pentru o zi. Primesc instrumente și un mod de lucru pe
              care îl aplică din săptămâna următoare.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3A — CE LUCRĂM ÎN TRAINING */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-1071">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1072">
          <div className="text-center mb-16" data-id="element-1073">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-4" data-id="element-1074">
              Modulele din care construim training-ul personalizat pentru echipa
              ta
            </h2>
          </div>
          <div className="flex flex-col gap-8" data-id="element-1075">
            {[{
            title: 'Profilare DISC pentru fiecare membru al echipei',
            items: ['Fiecare participant completează evaluarea DISC și primește un raport individual cu stilul lui de comunicare, ce îl motivează și ce îl stresează', 'Echipa primește harta completă a profilurilor: cine e D, cine e I, cine e S, cine e C și ce înseamnă asta pentru modul în care lucrează împreună', 'Valer explică pe loc de ce anumite conflicte sau blocaje din echipă sunt previzibile pe baza profilurilor și cum se gestionează']
          }, {
            title: 'Responsabilitate și asumare',
            items: ["Definim ce înseamnă responsabilitate reală în echipă: nu 'îmi fac treaba' ci 'răspund de un rezultat și îl urmăresc până la capăt'", 'Construim acordurile de asumare între membrii echipei: cine răspunde de ce, cum se comunică progresul și ce se întâmplă când ceva nu se face', "Eliminăm confuzia dintre 'am fost ocupat' și 'am produs un rezultat' prin indicatori clari per rol"]
          }, {
            title: 'Comunicare directă și constructivă',
            items: ['Echipa învață să dea feedback direct fără agresivitate și să primească feedback fără defensivitate', 'Introducem regulile de comunicare în ședințe: cum se ridică o problemă, cum se propune o soluție, cum se ia o decizie fără să ajungi în cerc', 'Lucrăm pe situații reale din echipă, nu pe cazuri fictive, astfel încât instrumentele se aplică pe loc']
          }, {
            title: 'Roluri clare și aliniere la viziune',
            items: ['Fiecare lider clarifică exact ce face, ce nu face, față de cine răspunde și cum este măsurat', 'Viziunea companiei este tradusă în contribuția concretă a fiecărui rol astfel încât fiecare om înțelege de ce contează munca lui', 'Eliminăm suprapunerile de responsabilitate și zonele gri în care nimeni nu se simte responsabil']
          }, {
            title: 'Încredere și coeziune',
            items: ['Construim exerciții prin care echipa învață să fie vulnerabilă fără să piardă respect, fundația încrederii reale', "Identificăm comportamentele care sabotează încrederea în echipă și le adresăm concret, nu prin discuții abstracte despre 'trust'", 'La finalul sesiunii, echipa are un set de reguli de lucru pe care le-au construit împreună și pe care le-au asumat public']
          }].map((block, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-[0_4px_20px_rgba(0,0,0,0.04)] border border-[rgba(0,0,0,0.04)]" data-id="element-1076">
                <div className="w-12 h-12 bg-[#EFF6FF] rounded-xl flex items-center justify-center mb-6 text-[#1D4ED8] font-bold text-xl" data-id="element-1077">
                  {index + 1}
                </div>
                <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-4" data-id="element-1078">
                  {block.title}
                </h3>
                <ul className="space-y-3" data-id="element-1079">
                  {block.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1080">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#1D4ED8] mt-2.5 flex-shrink-0" data-id="element-1081"></div>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-1082">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 4 — BENEFICII */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1083">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-1084">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-1085">
            Ce se schimbă în echipa ta după training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1086">
            {[{
            title: 'Fiecare om știe cum funcționează colegii lui',
            desc: 'Profilarea DISC elimină ghicitul. Echipa înțelege de ce unii vorbesc mult și alții tac, de ce unii vor detalii și alții vor viteză, și cum să comunice eficient unul cu celălalt.'
          }, {
            title: 'Responsabilitatea devine clară și asumată',
            desc: "Nu mai auzi 'credeam că face celălalt'. Fiecare rezultat are un singur responsabil cu termen și indicator."
          }, {
            title: 'Conflictele se adresează, nu se evită',
            desc: 'Echipa primește un mod structurat de a ridica probleme și de a le rezolva fără certuri, fără pasiv-agresivitate și fără acumulare de frustrări.'
          }, {
            title: 'Rolurile se clarifică odată pentru totdeauna',
            desc: 'Fiecare lider pleacă din training știind exact ce face, ce nu face și cum se măsoară contribuția lui la obiectivele companiei.'
          }, {
            title: 'Toată echipa vede aceeași direcție',
            desc: 'Viziunea nu mai stă doar în capul antreprenorului. Este tradusă în contribuția concretă a fiecărui rol și înțeleasă de toți.'
          }, {
            title: 'Ședințele devin productive',
            desc: 'Echipa învață un format de ședință care produce decizii, nu discuții interminabile. Aplică din prima săptămână după training.'
          }].map((benefit, i) => <div key={i} className="bg-[#F1F5F9] rounded-2xl p-6 border border-[rgba(0,0,0,0.04)]" data-id="element-1087">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mb-4 text-[#1D4ED8] shadow-sm" data-id="element-1088">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1089">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1090"></path>
                  </svg>
                </div>
                <h3 className="font-['Montserrat'] text-[18px] font-bold text-[#09111F] mb-2" data-id="element-1091">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-1092">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5 — CINE SUNT EU */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-1093">
        <div className="max-w-[800px] mx-auto px-5 md:px-12 text-center" data-id="element-1094">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-8" data-id="element-1095">
            Cine conduce training-ul și de ce contează experiența directă cu
            echipe reale
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] text-left" data-id="element-1096">
            <p data-id="element-1097">
              Sunt Valer Dura. De 12 ani lucrez direct cu antreprenori și
              echipele lor de lideri. Am construit, eficientizat și vândut
              propriile afaceri cu cifre de milioane de euro și știu din
              interior cum se simte să ai oameni buni care nu funcționează
              împreună.
            </p>
            <p data-id="element-1098">
              Nu sunt un trainer de sală care predă teorie despre leadership.
              Sunt certificat DISC și Maxwell Leadership și am facilitat sute de
              sesiuni cu echipe reale din companii românești. Știu cum arată o
              echipă disfuncțională nu din manuale, ci pentru că am avut una eu
              însumi și am reparat-o.
            </p>
            <p data-id="element-1099">
              Training-ul pe care îl conduc nu este motivațional. Nu pleci de
              acolo simțindu-te bine pentru o zi. Pleci cu instrumente concrete
              pe care le aplici din prima ședință de echipă de după training.
              Profiluri DISC completate. Roluri clarificate. Reguli de
              comunicare asumate. Mod de lucru structurat.
            </p>
            <p className="font-medium text-white border-l-4 border-[#3B82F6] pl-6 py-2" data-id="element-1100">
              Dacă vrei ca echipa ta să funcționeze diferit săptămâna viitoare,
              nu luna viitoare, training-ul acesta este gândit exact pentru
              asta.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1101">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1102">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1103">
            <div className="bg-[#EFF6FF] rounded-3xl p-8 border border-[rgba(59,130,246,0.2)]" data-id="element-1104">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-1105">
                <div className="w-8 h-8 rounded-full bg-[#1D4ED8] text-white flex items-center justify-center" data-id="element-1106">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1107">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1108"></path>
                  </svg>
                </div>
                Training-ul este pentru tine dacă:
              </h3>
              <ul className="space-y-4" data-id="element-1109">
                {['Ai o echipă de leadership de minimum 3 oameni care lucrează împreună dar nu funcționează ca echipă', 'Simți că ești mereu la mijloc: traduci între departamente, rezolvi conflicte, iei decizii pe care ei ar trebui să le ia', 'Ai oameni competenți individual dar comunicarea între ei este reactiv, nu proactiv'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1110">
                    <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-1111"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-1112">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FEF2F2] rounded-3xl p-8 border border-[rgba(239,68,68,0.2)]" data-id="element-1113">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-1114">
                <div className="w-8 h-8 rounded-full bg-[#EF4444] text-white flex items-center justify-center" data-id="element-1115">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1116">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-1117"></path>
                  </svg>
                </div>
                Training-ul nu este pentru tine dacă:
              </h3>
              <ul className="space-y-4" data-id="element-1118">
                {['Ai nevoie de recrutare, nu de dezvoltarea echipei existente, acest training lucrează cu oamenii pe care îi ai deja', 'Cauți un team-building de divertisment cu activități în aer liber, acest training este lucru serios pe probleme reale', 'Nu ești dispus ca antreprenor să participi activ la training alături de echipă, fără prezența ta rezultatele sunt incomplete'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1119">
                    <div className="w-2 h-2 rounded-full bg-[#EF4444] mt-2 flex-shrink-0" data-id="element-1120"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-1121">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — RECAPITULARE INVESTIȚIE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-1122">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1123">
          <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] relative" data-id="element-1124">
            <div className="absolute -top-4 inset-x-0 flex justify-center" data-id="element-1125">
              <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase px-6 py-2 rounded-full shadow-md" data-id="element-1126">
                RECAPITULARE
              </span>
            </div>
            <h2 className="font-['Montserrat'] text-[28px] md:text-[36px] font-bold text-[#09111F] mb-8 text-center mt-4" data-id="element-1127">
              Hai să recapitulăm ce primești în Training-ul Personalizat
            </h2>

            <div className="flex flex-col gap-12" data-id="element-1128">
              <div data-id="element-1129">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#1D4ED8] mb-6 border-b pb-2" data-id="element-1130">
                  Ce este inclus:
                </h3>
                <ul className="space-y-4" data-id="element-1131">
                  {['Sesiune de diagnostic pre-training cu antreprenorul: 60 de minute în care Valer înțelege situația reală a echipei, provocările specifice și obiectivele training-ului', 'Profilare DISC completă pentru fiecare participant cu raport individual', 'Training facilitat de Valer Dura, 1 sau 2 zile, adaptat pe nevoile echipei tale', 'Kit de materiale pentru fiecare participant: fișă de rol, reguli de comunicare, format de ședință', 'Raport de training trimis antreprenorului în 48 de ore cu observațiile lui Valer, recomandări și pașii următori'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-1132">
                      <svg className="w-5 h-5 text-[#1D4ED8] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1133">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-1134"></path>
                      </svg>
                      <span className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-1135">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-1136">
                <div className="bg-[#F1F5F9] rounded-xl p-6 text-center border border-[rgba(0,0,0,0.05)] h-full flex flex-col justify-center" data-id="element-1137">
                  <p className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-4" data-id="element-1138">
                    Investiție:
                  </p>
                  <p className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-1139">
                    Prețul exact se stabilește după sesiunea de diagnostic
                    pre-training pe baza situației reale a echipei tale.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-1140">
              <BookingButton text="Solicită o Ofertă Personalizată" href="/contact" className="px-10 py-5 text-[16px] w-full sm:w-auto" data-id="element-1141" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — TESTIMONIALE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1142">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-1143">
          <div className="text-center mb-16" data-id="element-1144">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-1145">
              Ce spun antreprenorii după training-ul cu echipa lor
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-1146">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-1147" />)}
          </div>
        </div>
      </section>

      {/* SECTION 9 — ÎNTREBĂRI FRECVENTE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-1148">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-1149">
          <div className="text-center mb-16" data-id="element-1150">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-1151">
              Întrebări Frecvente
            </h2>
          </div>
          <Accordion items={[{
          question: 'Câți participanți pot fi în training?',
          answer: 'Ideal între 4 și 15 persoane. Sub 4 nu se creează dinamica de echipă necesară. Peste 15 se pierde posibilitatea de lucru individual. Dacă ai o echipă mai mare de 15, putem organiza 2 sesiuni separate.'
        }, {
          question: 'Training-ul se face online sau fizic?',
          answer: 'Ambele formate funcționează. Training-urile fizice la sediul companiei au avantajul energiei de grup. Training-urile online prin Zoom cu Miro Board au avantajul flexibilității și al documentării automate a tot ce se lucrează. Prețul este același indiferent de format.'
        }, {
          question: 'Cât durează training-ul?',
          answer: 'Varianta standard este de o zi (6 până la 8 ore). Pentru echipe mai mari sau cu provocări mai complexe se recomandă 2 zile. Durata se stabilește în sesiunea de diagnostic pre-training.'
        }, {
          question: 'Ce trebuie să pregătesc înainte?',
          answer: 'Cu 2 săptămâni înainte, fiecare participant completează evaluarea DISC online, durează 15 minute. Valer pregătește rapoartele individuale și harta de echipă pe baza lor. Tu ca antreprenor ai o sesiune de diagnostic de 60 de minute în care îi spui lui Valer care sunt provocările reale.'
        }, {
          question: 'Pot combina training-ul cu ședința trimestrială?',
          answer: 'Da, și este o combinație recomandată. Ziua 1 training de echipă. Ziua 2 ședință trimestrială de planificare. Echipa iese din cele 2 zile cu relații clarificate, roluri asumate și un plan de 90 de zile construit împreună. Se negociază un preț comun.'
        }, {
          question: 'Ce se întâmplă dacă un lider cheie nu poate participa?',
          answer: 'Participarea tuturor liderilor este importantă. Dacă un om cheie lipsește, pierde contextul și nu asumă regulile construite de restul echipei. Se recomandă reprogramarea dacă un lider esențial nu poate fi prezent. Alternativ, Valer face o sesiune individuală de recuperare de 90 de minute cu persoana absentă.'
        }, {
          question: 'Cum măsurăm dacă training-ul a avut impact real?',
          answer: 'În sesiunea de check-in la 30 de zile evaluăm 3 lucruri: dacă ședințele săptămânale se țin în noul format, dacă comunicarea dintre lideri s-a schimbat vizibil și dacă antreprenorul a ieșit din rolul de mediator. Dacă aceste 3 indicatori nu s-au mișcat, discutăm ce a blocat implementarea și ajustăm.'
        }]} data-id="element-1152" />
        </div>
      </section>
    </div>;
}